<template>
  <div>
    <div id="container">
      <img src="../assets/close.svg" class="icon" id="close-icon" v-on:click="closeClicked">
      <div id="main-title">Submit your Business</div>
      <div class="title" id="about-title">About</div>
      <input class="input" v-model="form.name" @focus="onInputFocus($event)" ref="name" type="text" id="name" placeholder="Name of Business" autocomplete="new-password" required>
      <div id="address-container">
        <input class="input" v-model="form.address" @focus="onInputFocus($event)" ref="address" type="text" id="address" placeholder="Address" autocomplete="new-password" required>
        <input class="input" v-model="form.zip" @focus="onInputFocus($event)" ref="zip" type="text" id="zip" placeholder="Zip Code" autocomplete="new-password" required>
      </div>
      <div id="email-container">
        <input class="input" v-model="form.email" @focus="onInputFocus($event)" ref="email" type="text" id="email" autocomplete="new-password" required>
        <div id="email-placeholder">Your Email <span>(we will never display or share)</span></div>
      </div>
      <div id="years-container">
        <input class="input" v-model.number="form.years" @focus="onInputFocus($event)" ref="years" type="number" id="years" min="0" placeholder="Years in Business" autocomplete="new-password" required>
        <input class="input" v-model.number="form.employees" @focus="onInputFocus($event)" ref="employees" type="number" id="employees" min="1" placeholder="Number of Employees" autocomplete="new-password" required>
      </div>
      <sui-dropdown selection fluid v-model="form.industry" @focus="onInputFocus($event)" ref="industry" :options="industryOptions" id="industry" placeholder="Industry"/>
      <div class="title" id="issues-title">Issues</div>
      <sui-dropdown selection multiple fluid v-model="form.issues" @focus="onInputFocus($event)" ref="issues" :options="issuesOptions" id="issues" placeholder="You can select multiple"/>
      <div class="title" id="help-title">What happened and what can help?</div>
      <textarea v-model="form.help" @focus="onInputFocus($event)" ref="help" id="help" rows="5" placeholder="We want to hear how you’re doing! What can your customers do, and especially, what can our government do."/>
      <div class="title" id="links-title">Social Links <span>(optional)</span></div>
      <div id="copy-paste">Copy and paste in the URL for each social link.</div>
      <div id="copy-example">Example: <span>https://www.instagram.com/yoursitehere/</span></div>
      <input class="input social" v-model="form.website" type="url" id="website" placeholder="Website">
      <input class="input social" v-model="form.instagram" type="url" id="instagram" placeholder="Instagram">
      <input class="input social" v-model="form.facebook" type="url" id="facebook" placeholder="Facebook">
      <input class="input social" v-model="form.twitter" type="url" id="twitter" placeholder="Twitter">
      <div id="error-message" ref="error">*Please fill in required fields</div>
      <div id="buttons-container">
        <button id="submit-button" v-on:click="submitClicked">SUBMIT</button>
        <button id="cancel-button" v-on:click="closeClicked">CANCEL</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {industries, issues} from '../utils/constants'
  import {analytics} from '../main.js'
  import firebase from 'firebase/app'
  import 'firebase/firestore'

  export default {
    name: "Modal",
    data(){
      return {
        industryOptions: industries.map((it) => {
          return {value: it.value, text: it.text}
        }),
        issuesOptions: issues.map((it) => {
          return {value: it.value, text: it.text}
        }),
        form: {
          id: '',
          timestamp: null,
          name: '',
          address: '',
          zip: '',
          email: '',
          years: null,
          employees: null,
          industry: null,
          issues: [],
          help: '',
          website: '',
          instagram: '',
          facebook: '',
          twitter: ''
        },
        invalidInputs: []
      }
    },
    methods: {
      closeClicked() {
        this.$emit('hide')
      },
      submitClicked() {
        this.invalidInputs = []
        if (this.isFormValid()) {
          console.log("Valid Form")
          this.submitForm()
          this.$emit('hide')
          this.$emit('showThankYou')
          this.$refs.error.style.visibility = "hidden"
          // Clear form
          this.form = {
            id: '',
            timestamp: null,
            name: '',
            address: '',
            zip: '',
            email: '',
            years: null,
            employees: null,
            industry: null,
            issues: [],
            help: '',
            website: '',
            instagram: '',
            facebook: '',
            twitter: ''
          }
        } else {
          console.log("Invalid Form")
          this.$refs.error.style.visibility = "visible"
          this.invalidInputs.forEach((e) => {
            e.style.backgroundColor = "#FFEEEF"
            e.style.border = "1px solid #CE6363"
          })
        }
      },
      onInputFocus(event) {
        event.currentTarget.style.backgroundColor = "white"
        event.currentTarget.style.border = "1px solid #C7C7C7"
      },
      isFormValid() {
        if (!this.form.name) {
          this.invalidInputs.push(this.$refs.name)
        }
        if (!this.form.address) {
          this.invalidInputs.push(this.$refs.address)
        }
        if (!this.form.zip || !/^\d+$/.test(this.form.zip)) {
          this.invalidInputs.push(this.$refs.zip)
        }
        if (!this.isEmailValid(this.form.email)) {
          this.invalidInputs.push(this.$refs.email)
        }
        if (!this.form.years || this.form.years < 0) {
          this.invalidInputs.push(this.$refs.years)
        }
        if (!this.form.employees || this.form.employees < 0) {
          this.invalidInputs.push(this.$refs.employees)
        }
        if (!this.form.industry || this.form.industry === 0) {
          this.invalidInputs.push(this.$refs.industry.$el)
        }
        if (!this.form.issues || this.form.issues.length === 0) {
          this.invalidInputs.push(this.$refs.issues.$el)
        }
        if (!this.form.help) {
          this.invalidInputs.push(this.$refs.help)
        }
        return this.invalidInputs.length === 0
      },
      isEmailValid(email) {
        const re = /\S+@\S+\.\S+/
        return re.test(email)
      },
      submitForm() {
        analytics.logEvent('form_submitted')
        this.form.id = Math.random().toString(36).substring(7)
        this.form.timestamp = firebase.firestore.Timestamp.fromDate(new Date())
        firebase.firestore().collection("Businesses")
          .add(this.form)
          .then(() => {
            console.log("Document written", this.form)
          })
          .catch((error) => {
            console.error("Error writing document:", error)
          });
      }
    }
  }
</script>

<style scoped>
  @import "../fonts.css";

  #container {
    width: 420px;
    margin: 30px auto;
    padding: 0 30px 30px 30px;
    background-color: white;
    text-align: left;
    color: black;
    position: relative;
    -moz-box-shadow: 0 0 30px #151515;
    -webkit-box-shadow: 0 0 30px #151515;
    box-shadow: 0 0 30px #151515;
  }
  #close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  #close-icon:hover {
    opacity: 0.8;
  }
  #main-title {
    font-family: "Avenir Next", openSans, serif;
    font-weight: bold;
    font-size: 28px;
    margin-top: 30px;
    margin-bottom: 10px;
    display: inline-block;
    color: #232A2E;
  }
  .title {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
  }
  .title:before {
    content: "*";
    color: #CE6363;
  }
  .input {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    margin-top: 6px;
    padding: 12px 10px;
    width: 100%;
    background-color: white;
    border: 1px solid #C7C7C7;
    border-radius: 4px;
    box-sizing: border-box;
    outline: none;
    background-clip: padding-box; /*Removes shadow on iOS*/
    line-height: normal;
  }
  .input::placeholder {
    color: #C7C7C7;
    opacity: 1;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  #address-container {
    display: flex;
    margin-top: 6px;
  }
  #zip {
    margin-left: 10px;
    width: 40%;
  }
  #email-container {
    margin-top: 6px;
    position: relative;
  }
  #email-placeholder {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    margin-top: 6px;
    padding: 13px 11px;
    line-height: normal;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    color: #C7C7C7;
  }
  #email-container input:valid + #email-placeholder {
    display: none;
  }
  #email-placeholder span {
    color: #C7C7C7;
  }
  #years-container {
    display: flex;
    margin-top: 6px;
  }
  #employees {
    margin-left: 10px;
    width: 125%;
  }
  #industry {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    margin-top: 12px;
    padding: 15px 10px 15px 10px;
    width: 100%;
    background-color: white;
    border: 1px solid #C7C7C7;
    border-radius: 4px;
  }

  #issues-title {
    margin-top: 30px;
  }
  #issues {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    margin-top: 6px;
    padding-top: 7px;
    padding-bottom: 7px;
    width: 100%;
    background-color: white;
    border: 1px solid #C7C7C7;
    border-radius: 4px;
  }
  #help-title {
    margin-top: 30px;
  }
  #help {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    margin-top: 6px;
    padding: 12px 10px;
    width: 100%;
    background-color: white;
    border: 1px solid #C7C7C7;
    border-radius: 4px;
    box-sizing: border-box;
    outline: none;
    background-clip: padding-box; /*Removes shadow on iOS*/
    resize: vertical;
    data-gramm_editor: false;
  }
  #help::placeholder {
    color: #C7C7C7;
  }
  #links-title {
    margin-top: 30px;
  }
  #links-title:before {
    content: none;
  }
  #links-title span {
    font-family: "Avenir Next", openSans, serif;
    font-weight: 500;
    font-size: 14px;
    color: #C7C7C7;
  }
  #copy-paste, #copy-example {
    font-family: "Avenir Next", openSans, serif;
    font-size: 14px;
  }
  #copy-paste {
    margin-top: 8px;
  }
  #copy-example span {
    font-weight: 600;
  }
  .input.social {
    margin-top: 12px;
  }
  #buttons-container {
    display: flex;
    margin-top: 15px;
  }
  button {
    font-family: Futura, openSans, serif;
    font-weight: bold;
    font-size: 15px;
    border-radius: 4px;
    width: 100%;
    padding: 12px 0;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
  }
  #submit-button {
    border: 1.5px solid #232A2E;
    background-color: #232A2E;
    color: white;
    margin-right: 10px;
  }
  #cancel-button {
    border: 1.5px solid #232A2E;
    background-color: white;
    color: #232A2E;
  }
  #error-message {
    font-family: "Avenir Next", openSans, serif;
    font-weight: bold;
    font-size: 12px;
    color: #CE6363;
    text-align: center;
    margin-top: 15px;
    visibility: hidden;
  }
  #submit-button:hover {
    opacity: 0.95;
  }
  #cancel-button:hover {
    opacity: 0.7;
  }

  /*MOBILE*/
  @media only screen and (max-width: 768px) {
    #container {
      width: 94%;
      margin: 30px auto 60px auto;
      padding: 0 20px 20px 20px;
    }
    #main-title {
      font-size: 24px;
    }
    .title {
      font-size: 14px;
    }
    #links-title span {
      font-size: 12px;
    }
    #copy-paste, #copy-example {
      font-size: 12px;
    }
  }

  /*SMALL MOBILE*/
  @media only screen and (max-width: 360px) {
    #container {
      padding: 0 10px 10px 10px;
    }
    .input, #email-placeholder, #industry, #issues, #help {
      font-size: 11px;
    }
    .title {
      font-size: 13px;
    }
    #links-title span {
      font-size: 11px;
    }
    #copy-paste, #copy-example {
      font-size: 11px;
    }
  }
</style>